import { useState } from 'react';
import { X } from 'lucide-react';

/** Square hairline close button for the dark overlay cards (install prompts). */
export default function DismissButton({ onClick, label = 'Dismiss' }: { onClick: () => void; label?: string }) {
  const [hov, setHov] = useState(false);
  return (
    <button
      onClick={onClick}
      aria-label={label}
      onMouseEnter={() => setHov(true)}
      onMouseLeave={() => setHov(false)}
      style={{
        width: 28, height: 28, borderRadius: 8, flexShrink: 0,
        background: hov ? 'rgba(255,255,255,.07)' : 'transparent',
        border: `1px solid ${hov ? 'rgba(255,255,255,.15)' : 'rgba(255,255,255,.08)'}`,
        color: hov ? 'rgba(255,255,255,.7)' : 'rgba(255,255,255,.35)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        cursor: 'pointer', transition: '.2s',
      }}
    >
      <X size={13} aria-hidden />
    </button>
  );
}
